<main>
  <h1>{{data.title}}</h1>
  <div id="matspinner">
    <mat-spinner style="margin:0 auto;" color="accent" mode="indeterminate"></mat-spinner>
  </div>
</main>
